<template>
	<section id="mediakit" class="mediakit">
		<h2 class="mediakit__title heading h2">
			{{ $t('pages.main.sections.mediakit.title') }}
		</h2>
		<!-- <div class="mediakit__container container"> -->
		<div class="mediakit__content">
			<!-- <div class="mediakit__carousel">
					<div class="mediakit__slide">
						<img src="/images/sections/mediakit/hand.png" width="500" alt="hand" />
					</div>
				</div> -->
			<div class="mediakit__carousel">
				<img
					class="mediakit__carousel-hand"
					src="/images/sections/mediakit/hand2-nobg.webp"
					width="1200"
					alt="hand"
					loading="lazy"
					decoding="async" />
				<UICarousel
					class="mediakit__carousel-slider"
					:breakpoints="{
						0: { slidesPerView: 1 },
					}"
					:space-between="0"
					rewind
					custom-navigation
					:initial-slide="1"
					@swiper="handleSwiper">
					<SwiperSlide v-for="(img, i) in mediakitImages" :key="i">
						<template v-if="i === 7">
							<a
								:href="`/files/veon-adguide-${locale}.pdf`"
								target="_blank"
								download
								@click="handleDownloadMediakit">
								<img
									class="mediakit__carousel-img"
									:src="img"
									width="500"
									:alt="`${i}`"
									loading="lazy"
									decoding="async" />
							</a>
						</template>
						<template v-else>
							<div class="mediakit__carousel-slide" data-swiper-parallax="23%">
								<img
									class="mediakit__carousel-img"
									:src="img"
									width="500"
									:alt="`${i}`"
									loading="lazy"
									decoding="async" />
							</div>
						</template>
					</SwiperSlide>
				</UICarousel>
				<!-- <div class="mediakit__carousel-nav"> -->
				<button
					ref="leftBtn"
					type="button"
					class="mediakit__carousel-btn left"
					aria-label="Previous mediakit slide"
					@click="swiperRef?.slidePrev()">
					<Icon name="mdi:chevron-left" size="82" />
				</button>
				<button
					ref="rightBtn"
					type="button"
					class="mediakit__carousel-btn right"
					aria-label="Next mediakit slide"
					@click="swiperRef?.slideNext()">
					<Icon name="mdi:chevron-right" size="82" />
				</button>
				<!-- </div> -->
			</div>
		</div>
		<!-- </div> -->
	</section>
</template>

<script setup lang="ts">
	import { gsap } from 'gsap'
	import type { Swiper } from 'swiper/types'
	import { onMounted, ref } from 'vue'

	const swiperRef = ref<Swiper>()
	const leftBtn = ref(null)
	const rightBtn = ref(null)

	function handleSwiper(swiper: Swiper) {
		swiperRef.value = swiper
	}
	const { locale } = useI18n()
	const mediakitImages = computed(() => {
		return [
			'/images/sections/mediakit/iphone/1.webp',
			'/images/sections/mediakit/iphone/2.webp',
			'/images/sections/mediakit/iphone/3.webp',
			'/images/sections/mediakit/iphone/4.webp',
			'/images/sections/mediakit/iphone/5.webp',
			'/images/sections/mediakit/iphone/6.webp',
			'/images/sections/mediakit/iphone/7.webp',
			`/images/sections/mediakit/iphone/veon-adguide-${locale.value}.webp`,
		]
	})

	function addMagneticEffect(btnRef: Ref<HTMLElement | null>) {
		if (!btnRef.value || isMobile.value) return
		const btn = btnRef.value
		const strength = 40 // px, how far the button can move

		function onMouseMove(e: MouseEvent) {
			const rect = btn.getBoundingClientRect()
			const x = e.clientX - (rect.left + rect.width / 2)
			const y = e.clientY - (rect.top + rect.height / 2)
			gsap.to(btn, {
				x: (x / rect.width) * strength,
				y: (y / rect.height) * strength,
				duration: 0.3,
				ease: 'power3.out',
			})
		}
		function onMouseLeave() {
			gsap.to(btn, { x: 0, y: 0, duration: 0.5, ease: 'power3.out' })
		}
		btn.addEventListener('mousemove', onMouseMove)
		btn.addEventListener('mouseleave', onMouseLeave)
	}

	const isMobile = computed(() => {
		return import.meta.client ? window.innerWidth < 768 : false
	})

	const { reachGoal } = useYandexMetrika()

	function getMediakitAlt(index: number) {
		if (index === 7) return 'VEON mediakit preview'
		return `VEON mediakit slide ${index + 1}`
	}

	const handleDownloadMediakit = () => {
		reachGoal('download_mediakit')
	}

	onMounted(() => {
		addMagneticEffect(leftBtn)
		addMagneticEffect(rightBtn)
	})
</script>

<style scoped lang="scss">
	.mediakit {
		position: relative;
		top: -100px;
		padding: 64px 0 0;
		overflow: clip;

		// scroll-margin-top: 70px;
		background-color: var(--black);
		border-radius: 25px;

		@media screen and (width <= 768px) {
			padding: 64px 0;
		}
		&__title {
			color: var(--white);
			text-align: center;
			text-transform: uppercase;

			@media screen and (width <= 768px) {
				margin-bottom: 32px;
			}
		}
		&__content {
			position: relative;
		}
		&__carousel {
			position: relative;

			// overflow: hidden;
			z-index: 1;
			display: flex;
			align-items: center;
			justify-content: center;
			width: max-content;
			margin: 0 auto;

			@media (width <= 1198.99px) {
				width: 100%;
			}

			@media (width <= 768px) {
				transform: scale(1.5);
			}
			&-nav {
				position: absolute;
				top: 50%;
				left: 50%;
				z-index: 10;
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 100%;
				transform: translate(-50%, -50%);

				// button {
				// 	background-color: transparent;
				// 	border: none;
				// 	cursor: pointer;
				// 	&:hover,
				// 	&:active,
				// 	&:focus {
				// 		background-color: transparent;
				// 	}
				// }
			}
			&-btn {
				position: absolute;
				top: 50%;
				display: flex;
				flex-shrink: 0;
				align-items: center;
				justify-content: center;
				opacity: 0.5;
				transform: translateY(-50%);
				&.left {
					left: 0;
				}
				&.right {
					right: 0;
				}
				.iconify {
					background-color: var(--primary);
				}

				// transition:
				// 	0.5s opacity,
				// 	0.5s transform;
				&:hover {
					opacity: 1;
				}

				// &:active {
				// 	transform: scale(0.8);
				// }
				&::after {
					position: absolute;
					top: 50%;
					left: 50%;
					width: 100%;
					height: 100%;
					content: '';
					border: 2px solid var(--primary);
					border-radius: 50%;
					transform: translate(-50%, -50%);
				}

				@media (width <= 1198.98px) {
					top: 30%;
					opacity: 1;
					transform: scale(0.7);
					&.left {
						left: 10%;
					}
					&.right {
						right: 10%;
					}
					&::after {
						border: 0;
					}
				}

				@media (width <= 767.98px) {
					transform: scale(0.5);
					&.left {
						left: 15%;
					}
					&.right {
						right: 15%;
					}
				}
			}
			&-hand {
				position: relative;
				z-index: 1;
				pointer-events: none;
				backface-visibility: hidden;

				// overflow: hidden;
			}
			&-slider {
				position: absolute;
				top: 135px;
				left: 528px;
				z-index: 0;
				width: 210px;

				@media (width <= 1198.99px) {
					top: 17.4%;
					left: 44%;
					width: 17.4%;
					height: 56%;

					// width: 100%;
				}

				// overflow: auto;
			}
			&-img {
				max-height: 440px;
				object-fit: fill;
				border-radius: 25px;

				@media (width <= 1198.99px) {
					border-radius: 10px;
				}
			}

			// &-buttons {
			// 	position: absolute;
			// 	z-index: 5;
			// 	top: 50%;
			// 	left: 50%;
			// 	transform: translate(-50%, -50%);
			// 	width: 100%;
			// 	display: flex;
			// 	align-items: center;
			// 	justify-content: space-between;
			// }
			// &-btn {
			// 	color: var(--white);
			// }
		}
	}
	:deep(.swiper) {
		overflow: visible;
	}
	:deep(.swiper-slide) {
		position: relative;
		overflow: hidden;
		pointer-events: none;
		border-radius: 25px;
		opacity: 0.5;
		filter: blur(8px);
		transform: scale(0.8);
		transform-origin: bottom;
		transition:
			0.4s transform,
			0.4s opacity,
			0.4s filter;
		will-change: filter;

		@media (width <= 1198.99px) {
			// max-height: 420px;
			border-radius: 10px;
		}
	}
	:deep(.swiper-slide-active) {
		pointer-events: all;
		opacity: 1;
		filter: blur(0);
		transform: scale(1);
	}
	:deep(.swiper-navigation) {
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 10;
		justify-content: space-between;
		width: 100%;
		transform: translate(-50%, 50%);
		.button-next,
		.button-prev {
			font-size: 64px;
			color: var(--primary);
			background-color: unset;
			border: none;
			&:hover,
			&:active,
			&:focus {
				color: var(--primary);
				background-color: unset;
			}
		}
	}
</style>
